import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'outlaw-ring-loader',
  templateUrl: './ring-loader.component.html',
  styleUrls: ['./ring-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RingLoaderComponent {
  size = input(56);
  progress = input<number | null>(null);
  text = input('');

  protected radius = computed(() => this.size() / 2 - 4);
  protected circumference = computed(() => 2 * Math.PI * this.radius());
  protected dashOffset = computed(() => {
    const p = this.progress();
    if (p === null) return this.circumference() * 0.27; // ~73% arc for indeterminate
    return this.circumference() - (this.circumference() * p / 100);
  });
}
